<template>
  <div v-if="show" class="pageHeader">
    <div class="title">
      {{ title }}
    </div>
    <div class="subtitle">
      共 {{ virusTripList.length }} 条结果，数据更新截止时间 {{ updateTime }}
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    computed : {
      ...mapState( 'virusTrip', [
        'searchType', 'city', 'searchDate', 'travelNumber', 'updateTime'
      ] ),

      ...mapGetters( 'virusTrip', [ 'virusTripList' ] ),

      show() {
        return this.title || this.updateTime;
      },

      titleDate() {
        let result;

        result = '';

        if ( this.searchDate ) {
          result = this.searchDate.split( '-' );
          result.shift();
          result = result.join( '/' );
        }

        return result;
      },

      titleTravelNumber() {
        let result;

        result = '';

        if ( this.travelNumber ) {
          result = '「' + this.travelNumber + '」';
        }

        return result;
      },

      title() {
        let result;

        if ( this.searchType === 'city' ) {
          result = '与全部城市相关的结果';

          if ( this.city ) {
            result = '与「' + this.city + '」相关的结果';
          }
        } else if ( this.searchType === 'train' ) {
          result = '全部火车行程查询结果';

          if ( this.searchDate || this.travelNumber ) {
            result = this.composeTitle();
          }
        } else if ( this.searchType === 'flight' ) {
          result = '全部航班行程查询结果';

          if ( this.searchDate || this.travelNumber ) {
            result = this.composeTitle();
          }
        }

        return result;
      }
    },

    methods : {
      composeTitle() {
        let result;

        result = this.titleDate;

        if ( this.titleTravelNumber ) {
          result += '包含' + this.titleTravelNumber;
        }

        if ( this.searchType === 'train' ) {
          result += '的列车';
        } else {
          result += '的航班';
        }

        return result;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./page-header.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/page-header.vue